module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "additional-pages"
  }, [_c('nav', {
    staticClass: "sub-menu"
  }, [_c('span', {
    staticClass: "button-wrapper",
    on: {
      "click": _vm.handleAddPage
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v("Страница")]), _vm._v(" "), _c('ul', {
    staticClass: "centered"
  }, _vm._l((_vm.pages), function(item) {
    return _c('li', {
      on: {
        "click": function($event) {
          return _vm.getPage(item.id)
        }
      }
    }, [_c('router-link', {
      key: item.id,
      class: !_vm.$route.params.id && item.id === _vm.pages[0].id ? 'is-active' : '',
      attrs: {
        "to": {
          name: 'AdditionalPage',
          params: {
            id: item.id
          }
        },
        "active-class": "is-active"
      }
    }, [_vm._v("\n          " + _vm._s(item.title) + "\n        ")])], 1)
  }), 0)]), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2227a12e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AdditionalPages/Index.vue
// module id = 909
// module chunks = 0